import { Outlet } from 'react-router-dom';
import {
  FiBriefcase,
  FiUsers,
  FiUser,
  FiEye,
  FiLock,
  FiPackage,
  FiMapPin,
} from 'react-icons/fi';
import { useAuthStore } from '../../../store/authStore';
import { isAdmin } from '../../../lib/roles';
import SettingsTabs from './SettingsTabs';

/**
 * Nested layout for /settings/* — sub-navigation + outlet.
 */
function SettingsLayout() {
  const user = useAuthStore((s) => s.user);
  const admin = isAdmin(user);

  const items = [
    admin && { to: '/settings/organization', label: 'Organisation', icon: FiBriefcase },
    admin && { to: '/settings/team', label: 'Team', icon: FiUsers },
    { to: '/settings/profile', label: 'Profile', icon: FiUser },
    { to: '/settings/appearance', label: 'Appearance', icon: FiEye },
    { to: '/settings/security', label: 'Security', icon: FiLock },
    admin && { to: '/settings/assets', label: 'Assets', icon: FiPackage },
    admin && { to: '/settings/sites', label: 'Manage sites', icon: FiMapPin },
  ].filter(Boolean);

  return (
    <div className="settings-shell">
      <SettingsTabs items={items} />
      <div className="settings-shell-main">
        <Outlet />
      </div>
    </div>
  );
}

export default SettingsLayout;
